import { IApplicationState } from '../../types/redux';

export function getName(state: IApplicationState) {
  return state.newbuilding.name;
}
